/**
 * This should have static to list field names (aka htmlNames, <input name>, json key name, etc...).
 */
class FieldHtmlNameUtil {
    static getAllMqlFields() {
        return [
            FieldHtmlNameUtil.badFirstName,
            FieldHtmlNameUtil.badLastName,
            FieldHtmlNameUtil.disposalEmail,
            FieldHtmlNameUtil.competitorEmail,
            FieldHtmlNameUtil.desirableEmail,
            FieldHtmlNameUtil.badJobTitle,
            FieldHtmlNameUtil.badCompanyName,
            FieldHtmlNameUtil.badPhoneNumber,
        ];
    }
}
FieldHtmlNameUtil.email = 'email';
FieldHtmlNameUtil.desirableEmail = 'desdomain';
FieldHtmlNameUtil.competitorEmail = 'competitor';
FieldHtmlNameUtil.disposalEmail = 'disposal';
FieldHtmlNameUtil.firstName = 'firstName';
FieldHtmlNameUtil.badFirstName = 'bfname';
FieldHtmlNameUtil.lastName = 'lastName';
FieldHtmlNameUtil.badLastName = 'blname';
FieldHtmlNameUtil.phoneNumber = 'phoneNumber';
/** @deprecated phoneNumber (used by Demo Request, perhaps others) */
FieldHtmlNameUtil.pNumber = 'pnumber';
FieldHtmlNameUtil.badPhoneNumber = 'qphone';
FieldHtmlNameUtil.jobTitle = 'jobTitle';
FieldHtmlNameUtil.badJobTitle = 'bjobtitle';
FieldHtmlNameUtil.companyName = 'companyName';
FieldHtmlNameUtil.badCompanyName = 'bcompany';
FieldHtmlNameUtil.privacyConsentAccepted = 'privacyConsentAccepted';
FieldHtmlNameUtil.chooseOnshapeEvaluatingStatus = 'chooseOnshapeEvaluatingStatus';
FieldHtmlNameUtil.numberOfCadUsers1 = 'numberofCADUsers1';
FieldHtmlNameUtil.primaryCadSystem = 'cadsystem';
FieldHtmlNameUtil.maxCountry = 'maxcountry';
FieldHtmlNameUtil.maxState = 'maxstate';
FieldHtmlNameUtil.maxCity = 'maxcity';
FieldHtmlNameUtil.reasonForDownloading = 'reasonForDownloading';
FieldHtmlNameUtil.industry = 'industry1';
FieldHtmlNameUtil.websiteurl = 'websiteurl';
FieldHtmlNameUtil.submit = 'submit';
FieldHtmlNameUtil.companyRevenue = 'companyRevenue';
/** The name of the field that olds the trial plan ID (e.g. PRO_COMPANY_TRIAL) */
FieldHtmlNameUtil.planId = 'planId';
/** @deprecated use maxCountry instead */
FieldHtmlNameUtil.country = 'country';
FieldHtmlNameUtil.recaptcha = 'hekateRecaptcha';
FieldHtmlNameUtil.approveUser = 'approveUser';
FieldHtmlNameUtil.isEvalCenter = 'evalCenter';
FieldHtmlNameUtil.educationType = 'educationType';
FieldHtmlNameUtil.schoolLevel = 'schoolLevel';
FieldHtmlNameUtil.schoolName = 'schoolName';
FieldHtmlNameUtil.schoolTitlePosition = 'schoolTitlePosition';
FieldHtmlNameUtil.educatorOf = 'educatorOf';
FieldHtmlNameUtil.abVersion = 'abVersion';
/** aka the "I am a" question on the Eval Center sign up Form */
FieldHtmlNameUtil.chooseCadUserOrManagerStatus = 'chooseCadUserOrManagerStatus';
/** Questions for edu forms */
FieldHtmlNameUtil.isFacultyOrVolunteer = 'isFacultyOrVolunteer';
/** Questions for edu forms */
FieldHtmlNameUtil.isUsingForEducationOnly = 'isUsingForEducationOnly';
/** Questions for edu forms */
FieldHtmlNameUtil.isThirteenYearsOldOrSupervised = 'isThirteenYearsOldOrSupervised';
/** Questions for edu forms */
FieldHtmlNameUtil.isUsingForOwnEducation = 'isUsingForOwnEducation';
/** Questions for edu forms */
FieldHtmlNameUtil.isAgreeToTermsOfService = 'isAgreeToTermsOfService';
FieldHtmlNameUtil.isCadInClassEducator = 'isCadInClassEducator';
FieldHtmlNameUtil.yearOfGraduation = 'yearOfGraduation';
FieldHtmlNameUtil.useOfOnshapeComment = 'useOfOnshapeComment';
FieldHtmlNameUtil.areaOfStudyOrDegree = 'areaOfStudyOrDegree';
FieldHtmlNameUtil.formVariant = 'formVariant';
FieldHtmlNameUtil.hiddenStaticField1 = 'hiddenStaticField1';
FieldHtmlNameUtil.hiddenStaticField2 = 'hiddenStaticField2';
FieldHtmlNameUtil.proTrialChooseOnshapeEvaluatingStatus = 'proTrialChooseOnshapeEvaluatingStatus';
FieldHtmlNameUtil.isPremiumContentSubscription = 'isPremiumContentSubscription';
FieldHtmlNameUtil.isUpcomingEventsSubscription = 'isUpcomingEventsSubscription';
FieldHtmlNameUtil.isOnshapeNewsletterSubscription = 'isOnshapeNewsletterSubscription';
FieldHtmlNameUtil.isBlogRoundUpSubscription = 'isBlogRoundUpSubscription';
FieldHtmlNameUtil.preferredLanguage = 'preferredLanguage';
FieldHtmlNameUtil.isUnsubscribe = 'isUnsubscribe';
FieldHtmlNameUtil.isHPremiumContentSubscription = 'isHPremiumContentSubscription';
FieldHtmlNameUtil.isHUpcomingEventsSubscription = 'isHUpcomingEventsSubscription';
FieldHtmlNameUtil.isHOnshapeNewsletterSubscription = 'isHOnshapeNewsletterSubscription';
FieldHtmlNameUtil.isHBlogRoundUpSubscription = 'isHBlogRoundUpSubscription';
FieldHtmlNameUtil.isHUnsubscribe = 'isHUnsubscribe';
FieldHtmlNameUtil.referrerFullName = 'referrerFullName';
FieldHtmlNameUtil.businessUnit = 'businessUnit';
FieldHtmlNameUtil.utmSource = 'utm_source';
FieldHtmlNameUtil.utmMedium = 'utm_medium';
FieldHtmlNameUtil.utmCampaign = 'utm_campaign';
FieldHtmlNameUtil.utmGclid = 'utm_gclid';
FieldHtmlNameUtil.wwwSiteLanguage = 'wwwSiteLanguage';
FieldHtmlNameUtil.referringWwwFormUrl = 'referringWwwFormUrl';
FieldHtmlNameUtil.offsiteReferringUrl = 'offsiteReferringUrl';
FieldHtmlNameUtil.howDidYouHearAboutUsSummary = 'howDidYouHearAboutUsSummary';
FieldHtmlNameUtil.haveColleaguesInterestedInTrial = 'haveColleaguesInterestedInTrial';
FieldHtmlNameUtil.pauseEmailsExpiry = 'pauseEmailsExpiry';
FieldHtmlNameUtil.pauseEmailsFor30 = 'pauseEmailsFor30';
FieldHtmlNameUtil.isHPauseEmailsFor30 = 'isHPauseEmailsFor30';
FieldHtmlNameUtil.whatBestDescribesYou = 'whatBestDescribesYou';
FieldHtmlNameUtil.howDidYouHearAboutUs = 'howDidYouHearAboutUs';
FieldHtmlNameUtil.numberOfCadUsers = 'numberOfCadUsers';
FieldHtmlNameUtil.currentCadSystem = 'cadsystem';
FieldHtmlNameUtil.levelOfInterestInNewCad = 'levelOfInterestInNewCad';
FieldHtmlNameUtil.timeframeForDecision = 'timeframeForDecision';
FieldHtmlNameUtil.readyToUpgrade = 'readyToUpgrade';
FieldHtmlNameUtil.yearsOfCommitment = 'yearsOfCommitment';
FieldHtmlNameUtil.billingEmail = 'billingEmail';
FieldHtmlNameUtil.billingAddress = 'billingAddress';
export default FieldHtmlNameUtil;
